import { c as _c } from "react/compiler-runtime";
import React from 'react';
import useBazaarVoice from 'hooks/useBazaarVoice';
import BVHelmet from 'components/consumer/PDP/BazaarVoice/BVHelmet';
import usePDPBasicDetails from '../state/context/usePDPBasicDetails';
const PDPRatingsSection = () => {
  const $ = _c(6);
  const {
    isReady
  } = useBazaarVoice();
  const basicDetails = usePDPBasicDetails();
  const baseSku = basicDetails?.data?.sku || null;
  if (!baseSku) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <BVHelmet />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== baseSku || $[2] !== isReady) {
    t1 = isReady && <div key={baseSku} data-bv-show="rating_summary" data-bv-product-id={baseSku} />;
    $[1] = baseSku;
    $[2] = isReady;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <>{t0}{t1}</>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default PDPRatingsSection;